import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 22px 0 16px 16px;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    padding: 16px 0 12px 12px;
  }
`

export const Title = styled.h4`
  margin: 0;
  font-weight: 600;
  color: ${COLORS.secondaryDark};
`
